/** 回购页面 **/
<template>
  <div class="home data-panel-home">
    <Layout
      type="HOME"
      :pageTitle="$t('pageTitle')"
      titleSrc="/menu/homeIcon_black.png"
    >
      <Tips
        :title="$t('提现注意事项')"
        :tips="tips"
        class="buyback-tips"
      />
      <CommitBuyBack type="94" ></CommitBuyBack>
      <!-- <BuyBackAddress></BuyBackAddress> -->
      <BuyBackList></BuyBackList>
    </Layout>
  </div>

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Layout from "@/components/DatePanel/Layout.vue";
import Tips from '@/components/Common/Tips.vue';
import CommitBuyBack from '@/components/Withdrawal/CommitBuyBack.vue';
import BuyBackList from '@/components/Withdrawal/BuyBackList.vue';
import BuyBackAddress from '@/components/Withdrawal/BuyBackAddress.vue';

export default {
  name: "home",
  components: {
    Header,
    Layout,
    Tips,
    CommitBuyBack,
    BuyBackList,
    BuyBackAddress
  },
  computed: mapState({
    discount: state => state.buyBack.discount,
    minAmount: state => state.buyBack.minAmount,
    maxAmount: state => state.buyBack.maxAmount,
    BUYBACK_COUNT: state => state.buyBack.BUYBACK_COUNT,
    BUYBACK_MONEY_COUNT: state => state.buyBack.BUYBACK_MONEY_COUNT,
    TYPE_1_SHUI: state => state.buyBack.TYPE_1_SHUI,
    tips() {
        return [
          "1.支付宝提现需完成高级实名验证，验证前往：账号设置-身份验证-<router-link>高级实名验证<===>/contact<router-link>",
          `2.单次最小提现金额为 ${this.minAmount || "-"} 元，最大提现金额为 ${this.maxAmount || "-"} 元，由于税务限制，单人单月可提现总额为 30000 元。`,
          "3.目前仅支持提现到支付宝账户，请在提交申请时填写支付宝账号及真实姓名（同实名验证本人）。",
          "4.发起提现申请后，会在 1-2 个工作日直接转账至填写的支付宝账号。",
          `5.提现需要代扣除 ${this.TYPE_1_SHUI || '-'} 所得税点，测试期内暂时为代扣 5%（平台垫付 1%）。`
      ];rs
    }
  })
};
</script>

<style scoped lang="stylus"></style>

<i18n>
{
  "en": {
    "pageTitle": "提现",
    "tipsTitle": "提现注意事项"  
  }
}
</i18n>
